import { CheckCircleRounded, ErrorRounded } from '@mui/icons-material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Avatar, Box, Divider, List, ListItem, ListItemText, Paper, Stack, Tab, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { InspectionIcon } from 'app/icons';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

function formatInspectionModeLabel(mode) {
  const options = config.clientUi === 'voykan' ? config.inspectionModeOptionsVoykan : config.inspectionModeOptions;
  const matched = options.find((item) => item.value === (mode || ''));
  return matched?.title || options.find((item) => item.value === '')?.title || '';
}

const ChecklistInspectionViewItem = (props) => {
  const { checkpoint = [], result, index } = props;
  const [type = '', title = '', , required = false] = checkpoint;
  const status = required ? !result : false;

  if (!type || !title) return null;

  // TODO: refactor later
  const safeReactNode = (value) => {
    if (React.isValidElement(value)) return value;
    if (typeof value === 'string') return value;
    if (typeof value === 'number') return value.toString();
    if (typeof value === 'boolean') return value ? 'Да' : 'Нет';
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      if (value.checked !== undefined) {
        if (typeof value !== 'boolean') {
          return '-';
        } else {
          return value.checked ? 'Да' : 'Нет';
        }
      }

      if (!Array.isArray(value) && Object.keys(value).length > 0) {
        console.error('Объект в текстовом поле:', value);
        return 'Некорректные данные';
      }
      return null;
    }
    return String(value);
  };

  switch (type) {
    case 'text':
    case 'number':
    case 'vehicle_mileage':
    case 'trailer_license_plate':
    case 'vehicle_license_plate':
    case 'date':
    case 'hose_check_date':
    case 'dk_tractor_date':
    case 'sr_un1203_date':
    case 'osago_date':
    case 'dopog_tractor_date':
    case 'tacho_calib_date':
    case 'fe_op2_date':
    case 'dk_ppc_date':
    case 'svid_poverka_date':
    case 'dopog_ppc_date':
    case 'fe_6kg_date':
    case 'first_aid_kit_date':
    case 'eye_wash_date':
    case 'instructions_date':
    case 'select':
      return (
        <ListItem data-error={status} key={index}>
          <ListItemText primary={title} />
          <ListItemText primary={safeReactNode(result)} />
        </ListItem>
      );
    case 'textarea':
      return (
        <ListItem
          key={index}
          data-error={status}
          sx={(theme) => ({
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: 0,
            overflow: 'hidden',
            '.MuiListItemText-root': {
              width: '100%',
              paddingTop: '8px',
              paddingBottom: '12px',
              paddingLeft: '16px',
              paddingRight: '16px',
              marginBottom: 0,
              borderBottom: '1px solid',
              borderColor: theme.palette.divider,
            },
            'p.MuiTypography-root': {
              paddingTop: '8px',
              paddingBottom: '12px',
              paddingLeft: '16px',
              paddingRight: '16px',
            },
          })}>
          <ListItemText primary={title} />
          <Typography component='p'>{safeReactNode(result) ?? 'Нет данных'}</Typography>
        </ListItem>
      );
    case 'photo':
      return (
        <ListItem
          key={index}
          data-error={status}
          sx={(theme) => ({
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: 0,
            overflow: 'hidden',
            '.MuiListItemText-root': {
              width: '100%',
              paddingTop: '8px',
              paddingBottom: '12px',
              paddingLeft: '16px',
              paddingRight: '16px',
              marginBottom: 0,
              borderBottom: '1px solid',
              borderColor: theme.palette.divider,
            },
          })}>
          <ListItemText primary={title} />
          <Box
            component='div'
            sx={{
              width: '100%',
              height: '200px',
              bgcolor: 'black',
              'a, img': {
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              },
            }}>
            <a href={`${location.origin}/resources/${result}`} target='_blank'>
              <img src={`${location.origin}/resources/${result}`} alt='' />
            </a>
          </Box>
        </ListItem>
      );
    case 'boolean':
      return typeof result === 'object' ? (
        <>
          <ListItem
            sx={() => ({
              paddingLeft: '20px',
              flexDirection: 'column',
              alignItems: 'start',
            })}
            data-error={status}
            key={`${index}-checkbox`}>
            <Box
              sx={() => ({
                display: 'flex',
                alignItems: 'center',
                width: '100%',
              })}>
              <ListItemText primary={title} />
              {result.checked ? <CheckCircleRounded fontSize='small' color='success' /> : <ErrorRounded fontSize='small' color='error' />}
            </Box>
            {result?.comment && (
              <Box
                sx={() => ({
                  paddingLeft: '20px',
                })}>
                <ListItemText primary='Комментарий:' />
                <Typography variant='body2'>{result.comment}</Typography>
              </Box>
            )}
            {result?.photo && (
              <Box
                sx={() => ({
                  paddingLeft: '20px',
                  width: '100%',
                })}>
                <ListItemText primary='Фото:' />
                <Box
                  component='div'
                  sx={{
                    width: '100%',
                    height: '200px',
                    bgcolor: 'black',
                    'a, img': {
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    },
                  }}>
                  <a href={`${location.origin}/resources/${result.photo}`} target='_blank'>
                    <img src={`${location.origin}/resources/${result.photo}`} alt='inspection photo' />
                  </a>
                </Box>
              </Box>
            )}
          </ListItem>
        </>
      ) : (
        <ListItem data-error={status} key={index}>
          <ListItemText primary={title} />
          {result ? <CheckCircleRounded fontSize='small' color='success' /> : <ErrorRounded fontSize='small' color='error' />}
        </ListItem>
      );
    default:
      return null;
  }
};

const inspectionResultListSx = (theme) => ({
  '.MuiListItem-root': {
    border: '1px solid',
    borderColor: theme.palette.divider,
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
    '&[data-error="true"]': {
      borderColor: theme.palette.error.main,
    },
    '&:last-of-type': {
      marginBottom: 0,
    },
    '.MuiListItemText-root:nth-of-type(1) span': {
      color: theme.palette.text.secondary,
    },
    '.MuiListItemText-root:nth-of-type(2)': {
      textAlign: 'right',
    },
  },
});

const InspectionResultsList = ({ item }) => (
  <List sx={inspectionResultListSx}>
    {item.checkpoints.map((checkpoint, index) => {
      if (checkpoint.length === 2) {
        const [title, data] = checkpoint;
        return (
          <Stack
            key={index}
            direction='column'
            sx={(theme) => ({
              marginBottom: theme.spacing(2),
              paddingBottom: theme.spacing(2),
              borderBottom: '1px solid',
              borderColor: theme.palette.divider,
            })}>
            <Divider
              textAlign='center'
              sx={(theme) => ({
                width: '100%',
                alignSelf: 'center',
                justifyContent: 'center',
                marginTop: theme.spacing(0),
                marginBottom: theme.spacing(2),
              })}>
              <Typography variant='body2'>{title}</Typography>
            </Divider>
            {data.map((checkpoint, subIndex) => (
              <ChecklistInspectionViewItem
                key={`${index}.${subIndex}`}
                checkpoint={checkpoint}
                result={item.results[index]?.[subIndex]}
                index={`${index}.${subIndex}`}
              />
            ))}
          </Stack>
        );
      } else {
        return <ChecklistInspectionViewItem key={index} checkpoint={checkpoint} result={item.results[index]} index={index} />;
      }
    })}
  </List>
);

const ChecklistInspectionView = () => {
  const [tab, setTab] = useState('info');
  const { inspectionSelectedItem } = useSelector((state) => state.checklist);
  const isVoykanUi = config.clientUi === 'voykan';

  return (
    <Stack
      direction='column'
      alignItems='center'
      sx={(theme) => ({
        height: '100%',
        '& .MuiTabPanel-root': {
          width: '100%',
          padding: theme.spacing(2),
        },
        '& .MuiTabs-root': {
          padding: theme.spacing(2),
        },
      })}>
      {inspectionSelectedItem && isVoykanUi && (
        <Stack
          direction='column'
          alignItems='stretch'
          sx={(theme) => ({
            maxWidth: 'min(960px, 100%)',
            width: '100%',
            height: 'auto',
            padding: theme.spacing(2),
            alignSelf: 'stretch',
          })}>
          <Paper
            elevation={0}
            sx={(theme) => ({
              width: '100%',
              padding: theme.spacing(2, 2.5),
              border: '1px solid',
              borderColor: theme.palette.divider,
              borderRadius: theme.shape.borderRadius,
              bgcolor: 'background.paper',
              marginBottom: theme.spacing(2),
            })}>
            <Stack direction='row' alignItems='center' justifyContent='space-between' flexWrap='wrap' sx={{ gap: 2 }}>
              <Typography
                variant='subtitle1'
                component='h2'
                sx={{
                  fontWeight: 600,
                  flex: '1 1 220px',
                  minWidth: 0,
                  lineHeight: 1.35,
                  fontSize: '0.9375rem',
                }}>
                {inspectionSelectedItem.name}
              </Typography>
              <Typography variant='body1' sx={{ whiteSpace: 'nowrap' }}>
                <Box component='span' color='text.secondary' sx={{ mr: 0.5 }}>
                  Бригада:
                </Box>
                {inspectionSelectedItem.number || '—'}
              </Typography>
              <Typography variant='body1' color='text.secondary' sx={{ whiteSpace: 'nowrap' }}>
                {moment(inspectionSelectedItem.created_at).format('DD.MM.YYYY HH:mm:ss')}
              </Typography>
              {inspectionSelectedItem.delivered_at ? (
                <Typography variant='body2' color='text.secondary' sx={{ whiteSpace: 'nowrap' }}>
                  Доставлено {moment(inspectionSelectedItem.delivered_at).format('DD.MM.YYYY HH:mm:ss')}
                </Typography>
              ) : null}
            </Stack>
          </Paper>
          <Stack
            direction='column'
            alignItems='stretch'
            sx={(theme) => ({
              width: '100%',
              border: '1px solid',
              borderRadius: theme.shape.borderRadius,
              borderColor: theme.palette.divider,
              bgcolor: 'background.paper',
              padding: theme.spacing(2),
            })}>
            <Typography variant='subtitle1' sx={{ fontWeight: 600, mb: 1.5 }}>
              Результат осмотра
            </Typography>
            <InspectionResultsList item={inspectionSelectedItem} />
          </Stack>
        </Stack>
      )}
      {inspectionSelectedItem && !isVoykanUi && (
        <Stack
          direction='column'
          alignItems='center'
          sx={(theme) => ({
            maxWidth: '540px',
            width: '100%',
            height: 'auto',
            padding: theme.spacing(2),
          })}>
          <Stack
            direction='column'
            alignItems='center'
            sx={(theme) => ({
              marginBottom: theme.spacing(3),
              '.MuiAvatar-root': {
                width: '56px',
                height: '56px',
                bgcolor: theme.palette.primary.main,
              },
              '.MuiAvatar-circular': {
                color: theme.palette.primary.main,
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                svg: {
                  width: '30px',
                  height: '30px',
                },
                path: {
                  fill: theme.palette.primary.main,
                },
              },
              '.MuiTypography-root:first-of-type': {
                marginTop: theme.spacing(1),
              },
            })}>
            <Avatar>
              <InspectionIcon fontSize='large' />
            </Avatar>
            <Typography variant='body1'>{inspectionSelectedItem.name}</Typography>
          </Stack>
          <Stack
            direction='column'
            alignItems='center'
            sx={(theme) => ({
              width: '100%',
              height: 'auto',
              position: 'relative',
              border: '1px solid',
              borderRadius: theme.shape.borderRadius,
              borderColor: theme.palette.divider,
              bgcolor: 'background.paper',
            })}>
            <TabContext value={tab}>
              <TabList
                onChange={(event, value) => setTab(value)}
                TabIndicatorProps={{ children: <span /> }}
                sx={(theme) => ({
                  width: '100%',
                  minHeight: '44px',
                  borderBottom: '1px solid',
                  borderColor: theme.palette.divider,
                  '.MuiTab-root': {
                    fontSize: '12px',
                    minHeight: '44px',
                    padding: theme.spacing(2),
                    '&.Mui-selected': {
                      color: 'inherit',
                    },
                    '&:first-of-type': {
                      paddingLeft: 0,
                    },
                  },
                  '.MuiTabs-indicator': {
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                  },
                  '.MuiTabs-indicator span': {
                    width: 'calc(100% - ' + theme.spacing(4) + ')',
                    bgcolor: theme.palette.primary.main,
                    borderRadius: theme.shape.borderRadius,
                  },
                })}>
                <Tab value='info' label='Информация' disableRipple />
                <Tab value='result' label='Результат осмотра' disableRipple />
              </TabList>
              <TabPanel value='info'>
                <Stack
                  direction='column'
                  sx={(theme) => ({
                    width: '100%',
                    position: 'relative',
                    gap: '6px',
                    '.MuiPaper-label': {
                      position: 'absolute',
                      top: '10px',
                      left: theme.spacing(1),
                      padding: theme.spacing(0, 1),
                      bgcolor: 'background.paper',
                      fontWeight: '500',
                    },
                    '.MuiPaper-row': {
                      display: 'grid',
                      gap: 1,
                      gridTemplateColumns: 'repeat(4, 1fr)',
                      '.MuiTypography-root:first-of-type': {
                        color: 'text.secondary',
                      },
                    },
                    '.MuiPaper-row .MuiTypography-root:first-of-type': {
                      gridRow: '1',
                      gridColumn: '1/3',
                    },
                    '.MuiPaper-row .MuiTypography-root:last-of-type': {
                      gridRow: '1',
                      gridColumn: '3/5',
                      'span:nth-of-type(2)': {
                        paddingLeft: theme.spacing(0.5),
                      },
                    },
                  })}>
                  <Stack className='MuiPaper-row'>
                    <Typography variant='body1'>Название осмотра</Typography>
                    <Typography variant='body1'>{inspectionSelectedItem.name}</Typography>
                  </Stack>
                  <Stack className='MuiPaper-row'>
                    <Typography variant='body1'>Режим осмотра</Typography>
                    <Typography variant='body1'>{formatInspectionModeLabel(inspectionSelectedItem.inspection_mode)}</Typography>
                  </Stack>
                  <Stack className='MuiPaper-row'>
                    <Typography variant='body1'>Время проведения осмотра</Typography>
                    <Typography variant='body1'>{moment(inspectionSelectedItem.created_at).format('DD.MM.YYYY HH:mm:ss')}</Typography>
                  </Stack>
                  <Stack className='MuiPaper-row'>
                    <Typography variant='body1'>Координаты</Typography>
                    <Typography variant='body1'>
                      {inspectionSelectedItem.latitude}, {inspectionSelectedItem.longitude}
                    </Typography>
                  </Stack>
                  <Stack className='MuiPaper-row'>
                    <Typography variant='body1'>Госномер ТС</Typography>
                    <Typography variant='body1'>{inspectionSelectedItem.number}</Typography>
                  </Stack>
                  <Stack className='MuiPaper-row'>
                    <Typography variant='body1'>Госномер прицепа</Typography>
                    <Typography variant='body1'>{inspectionSelectedItem.trailer}</Typography>
                  </Stack>
                  <Stack className='MuiPaper-row'>
                    <Typography variant='body1'>ФИО сотрудника</Typography>
                    <Typography variant='body1'>{inspectionSelectedItem.employee}</Typography>
                  </Stack>
                  <Stack className='MuiPaper-row'>
                    <Typography variant='body1'>Статус</Typography>
                    <Typography variant='body1'>
                      {config.inspectionStatuses.find((item) => item.value === inspectionSelectedItem.status).label}
                    </Typography>
                  </Stack>
                </Stack>
              </TabPanel>
              <TabPanel value='result'>
                <InspectionResultsList item={inspectionSelectedItem} />
              </TabPanel>
            </TabContext>
          </Stack>
        </Stack>
      )}
      {!inspectionSelectedItem && (
        <Stack
          direction='column'
          alignItems='center'
          justifyContent='center'
          sx={(theme) => ({
            height: '100%',
            padding: theme.spacing(0, 2),
            '.MuiTypography-root': {
              borderRadius: '20px',
              marginTop: '24px',
              padding: theme.spacing(0.5, 2),
              bgcolor: alpha(theme.palette.grey.main, 0.12),
            },
          })}>
          <Typography align='center' color='text.secondary' variant='caption' component='label'>
            Выберите осмотр из списка
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default ChecklistInspectionView;
